export default "__VITE_ASSET__D71H9lJR__"